import {
	Button,
	ButtonGroup,
	Container,
	Divider,
	IconButton,
	Stack,
	Text,
	Box,
	Flex,
	Image,
} from '@chakra-ui/react';
import { Link as ReactLink } from "react-router-dom";
import { FaFacebook } from 'react-icons/fa';

const Footer = () => (
	<Box bg="white" py={10}>
		<Container maxW="7xl">
			<Stack spacing={10} direction={{ base: 'column', md: 'row' }} justify="space-between">
			
				<Stack spacing={4} align={{ base: 'center', md: 'start' }}>
					<Flex as={ReactLink} to='/' alignItems="center" gap={4}>
						<Image src="/images/laskoditesztalogo.png" width="80px" height="80px" />
						<Box   position='relative' alignItems="center" justifyContent='flex-start' display={{base:'none',md:'flex'}} flexDirection="column">
													<Text fontSize="2xl" as="b" href="#wave">
														LASKODI
													</Text>
													<Text  top={6} position='absolute' as="b" fontSize="15px" alignItems="center" >
														TÉSZTA
													</Text>
												</Box>
					</Flex>
				</Stack>
				<Stack direction={{ base: 'column', md: 'row' }} spacing={10} flex={1} justify="center">
					<Stack spacing={3} align={{ base: 'center', md: 'start' }}>
						<Text fontSize="md" fontWeight="semibold" color="gray.600">Menü</Text>
						<Button  as={ReactLink} to='/rolunk' variant="link" color="gray.500">Rólunk</Button>
						<Button  as={ReactLink} to='/tesztaink' variant="link" color="gray.500">Tésztáink</Button>
						<Button  as={ReactLink} to='/palyazat' variant="link" color="gray.500">Pályázat</Button>
						<Button  as={ReactLink} to='/kapcsolat' variant="link" color="gray.500">Kapcsolat</Button>
					</Stack>

					<Stack spacing={3} align={{ base: 'center', md: 'start' }}>
						<Text fontSize="md" fontWeight="semibold" color="gray.600">Információk</Text>
						<Button  data-disabled="" variant="link" color="gray.500">ÁSZF</Button>
						<Button data-disabled="" variant="link" color="gray.500">Adatkezelés</Button>
						<Button data-disabled="" variant="link" color="gray.500">Szállítás</Button>
					</Stack>
				</Stack>

				<Stack spacing={3} align={{ base: 'center', md: 'end' }}>
					<Text fontSize="md" fontWeight="semibold" color="gray.600">Elérhetőség</Text>
					<Text fontSize="sm" color="gray.500">Cím: 4543, Laskod Szabadság út 31.</Text>
					<Box>
					<Text fontSize="sm" color="gray.500">Telefon: <a href="tel:+36302181850">+36 30-2181-850</a></Text>
					<Text fontSize="sm" color="gray.500" align='end'> <a href="tel:+36305090425">+36 30-5090-425</a></Text>	
					</Box>
					<Box>
						<Text fontSize="sm" color="gray.500">Email: <a href="mailto:laskoditeszta@hu.inter.net">laskoditeszta@hu.inter.net</a></Text>
					<Text align='end' fontSize="sm" color="gray.500"><a href="mailto:aranytoj@hu.inter.net">aranytoj@hu.inter.net</a></Text>
					</Box>
					
				</Stack>
			</Stack>

			<Divider my={6} />
			<Stack direction={{ base: 'column', md: 'row' }} justify="space-between" align="center">
				<Text fontSize="sm" color="gray.500">&copy; {new Date().getFullYear()} Laskodi Tészta. Minden jog fenntartva.</Text>
				<ButtonGroup>
					<IconButton as='a' href='#' icon={<FaFacebook fontSize='1.5rem' />} colorScheme="blue" variant="ghost"/>
				</ButtonGroup>
			</Stack>
		</Container>
	</Box>
);

export default Footer;
